import React, { useEffect, useState } from 'react';
import { Row,Col,Card,Placeholder,Image,ListGroup } from 'react-bootstrap';
const Alumni = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[Alumnies,setAlumni]=useState([]);
    const[isLoading, setLoading] = useState(true);
    useEffect(()=>
    {
        alumniAll(); 
    },[])
    const alumniAll = async () => 
    {
        try 
        {
            const response = await fetch(global.config.API_URL+"alumni/all");
            const result = await response.json();
            if(result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.al_id + "/alPhoto")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.al_id + "/alPhotoHi")
                            .then(upb => upb.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp, upb]) => {
                                return {
                                    ...e,
                                    upp,
                                    upb
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].alPhoto = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                        result[i].alPhotoHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                    });
                    setAlumni(result);
                    setLoading(false);
                }).catch(error => {
                    console.error('Alumni File :', error);
                    setLoading(false);
                });
            }
            else
            {
                setAlumni([]);
                setLoading(false);
            }
            if( global.config.IsPrint === true ) { console.info('Alumni ALL : Result',result); }
        }
        catch (error) 
        {
            console.error('Alumni ALL : Error', error.message);
        }
    };
    return (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center fs-3' data-aos="flip-up" data-aos-duration="1500">
                { appLanguage === 'hi' ? 'पूर्व छात्र' : 'Alumni' }
            </Card.Header>
            <Card.Body>
            {isLoading ? (
                <Row className='g-3'>
                {[...Array(4)].map((_,index) => (
                    <Col md={6} key={index}>
                        <Card data-aos="flip-up" data-aos-duration="1000" className='bg-success-subtle'>
                            <Card.Header className='text-bg-primary fs-3'><Placeholder xs={10} bg="success" /></Card.Header>
                            <Card.Body><Placeholder xs={10} bg="success" /></Card.Body>
                        </Card>
                    </Col>
                ))}
                </Row>
            ) : (
                <Row className='g-3'>
                {Alumnies.map((al,index)=>(
                    <Col md={6} key={index}>
                        <Card data-aos="flip-up" data-aos-duration="1000" className='bg-success-subtle text-dark h-100'>
                            <Card.Header className='text-bg-primary fs-3 text-center'>
                                { appLanguage === 'hi' ? (al.al_display_en === "1" ? al.al_name_hi || '' : al.al_name_hi || al.al_name) : al.al_name }
                            </Card.Header>
                            <Card.Body>
                                {appLanguage === 'hi' ? 
                                    (
                                        al.alPhotoHi 
                                        ? <Image src={al.alPhotoHi} className="border w-100 mb-2" fluid /> 
                                        : al.alPhoto 
                                            ? <Image src={al.alPhoto} className="border w-100 mb-2" fluid /> 
                                            : null
                                    ) : (
                                        al.alPhoto 
                                        ? <Image src={al.alPhoto} className="border w-100 mb-2" fluid />
                                        : null
                                    )
                                }                                 
                                <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (al.al_display_en === "1" ? al.al_detail_hi || '' : al.al_detail_hi || al.al_detail) : al.al_detail }}></div>
                                <AlumniFiles alId={al.al_id} />
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
                </Row>
            )}
            </Card.Body>
        </Card>
    );
}
export default Alumni;
const AlumniFiles = ({alId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[Files,setFile]=useState([]);
    useEffect(()=>
    {
        const getFilesByAlumni = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"alumniFiles/byAlumni/"+alId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.alf_id + "/alfFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.alf_id + "/alfFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].alfFile = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].alfFileHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setFile(result);
                    }).catch(error => {
                        console.error('Alumni File :', error);
                    });
                }
                else
                {
                    setFile([]);
                }
                if( global.config.IsPrint === true ) { console.info('FilesByAlumni : Result',result); }
              
            } catch (error) 
            {
                console.error('FilesByAlumni : Error', error.message);
            }
        };
        getFilesByAlumni();    
    },[alId])
    return (
        <ListGroup variant="flush">
        {Files.map((alf,index)=>(
            <ListGroup.Item key={index} className='bg-transparent text-dark border-0 pe-0'>
                <div className='d-flex align-items-end justify-content-between'>
                    <div className='me-2'>
                        {index+1+'.'} { appLanguage === 'hi' ? (alf.alf_display_en === "1" ? alf.alf_name_hi || '' : alf.alf_name_hi || alf.alf_name) : alf.alf_name }
                    </div>
                    {appLanguage === 'hi' ? 
                        (
                            alf.alfFileHi 
                            ? <a className="badge text-bg-success" href={alf.alfFileHi}>यहाँ क्लिक करें</a>
                            : alf.alfFile 
                                ? <a className="badge text-bg-success" href={alf.alfFile}>यहाँ क्लिक करें</a>
                                : null
                        ) : (
                            alf.alfFile 
                            ? <a className="badge text-bg-success" href={alf.alfFile}>Click Here</a>
                            : null
                        )
                    }
                    {alf.alf_link && <a className="badge text-bg-success" href={alf.alf_link}>{appLanguage === 'hi' ? 'यहाँ क्लिक करें' : 'Click Here'}</a>}
                </div>                
            </ListGroup.Item>
        ))}
        </ListGroup> 
    );
}